import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createBlock as _createBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "md:mt-24 my-5 grid gap-y-3"
}
const _hoisted_2 = { class: "text-xl md:text-3xl font-medium" }
const _hoisted_3 = { class: "flex flex-col my-4 col-span-12 md:col-span-6" }
const _hoisted_4 = { class: "mb-2" }
const _hoisted_5 = { class: "flex flex-col my-4 col-span-6 md:col-span-4" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "CPF", -1)
const _hoisted_7 = { class: "flex flex-col my-4 col-span-6 md:col-span-2" }
const _hoisted_8 = { class: "mb-2" }
const _hoisted_9 = { class: "flex flex-col my-4 col-span-6 md:col-span-4" }
const _hoisted_10 = {
  key: 0,
  class: "flex flex-col my-4 col-span-6 md:col-span-2"
}
const _hoisted_11 = {
  key: 1,
  class: "flex flex-col my-4 col-span-6 md:col-span-2"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Status", -1)
const _hoisted_13 = {
  key: 2,
  class: "flex flex-col my-4 col-span-8 md:col-span-2"
}
const _hoisted_14 = {
  key: 3,
  class: "mt-5 col-span-12"
}
const _hoisted_15 = { class: "flex justify-between items-center p-4 bg-gray-200 rounded-md" }
const _hoisted_16 = {
  key: 0,
  class: "mt-5"
}
const _hoisted_17 = { class: "text-gray-400 font-bold" }
const _hoisted_18 = {
  key: 1,
  class: "mt-5"
}
const _hoisted_19 = { class: "grid grid-cols-12 gap-3" }
const _hoisted_20 = ["src"]
const _hoisted_21 = { class: "flex justify-between items-center" }
const _hoisted_22 = { class: "truncate max-w-fit" }
const _hoisted_23 = { class: "text-gray-400 line-clamp-2" }
const _hoisted_24 = { class: "flex items-center gap-3 col-span-12 mt-10" }
const _hoisted_25 = { class: "my-3 flex flex-col" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, "Curso(s)", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Errors = _resolveComponent("Errors")!
  const _component_InputMask = _resolveComponent("InputMask")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_AutoComplete = _resolveComponent("AutoComplete")!
  const _component_Button = _resolveComponent("Button")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_component_Loader, {
      loader: _ctx.formLoader,
      label: "Carregando...",
      loaderType: "progress"
    }, null, 8, ["loader"]),
    (!_ctx.formLoader)
      ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
          _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.isEditable ? "Editar " : "Cadastrar ") + "usuário ", 1),
          (_ctx.form)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (
          _ctx.form.role !== 'STUDENT' ? _ctx.submitUser() : _ctx.submitUserStudent()
        ), ["prevent"])),
                class: "grid grid-cols-12 gap-x-5",
                autocomplete: "off"
              }, [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$t("labels.generic", { pt: "Nome completo", en: "Fullname" })), 1),
                  _createVNode(_component_InputText, {
                    id: "name-input",
                    type: "text",
                    modelValue: _ctx.form.name,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.name) = $event)),
                    class: _normalizeClass(_ctx.v$.form.name.$error ? 'p-invalid' : '')
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_Errors, {
                    errors: _ctx.v$.form.name.$errors
                  }, null, 8, ["errors"])
                ]),
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createVNode(_component_InputMask, {
                    id: "cpf-input",
                    mask: "999.999.999-99",
                    modelValue: _ctx.form.cpf,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.cpf) = $event)),
                    unmask: true,
                    class: _normalizeClass(_ctx.v$.form.cpf.$error ? 'p-invalid' : '')
                  }, null, 8, ["modelValue", "class"]),
                  _createVNode(_component_Errors, {
                    errors: _ctx.v$.form.cpf.$errors
                  }, null, 8, ["errors"])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$t("labels.generic", {
                pt: "Data de nascimento",
                en: "Birthdate",
              })), 1),
                  _createVNode(_component_Calendar, {
                    inputId: "birthdate-input",
                    modelValue: _ctx.form.birthDate,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.birthDate) = $event)),
                    dateFormat: "dd/mm/yy"
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("p", {
                    class: _normalizeClass(`mb-2 ${_ctx.isEditable !== '' ? 'text-gray-500' : ''}`)
                  }, " E-mail ", 2),
                  _createVNode(_component_InputText, {
                    id: "login-input",
                    type: "text",
                    modelValue: _ctx.form.login,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.login) = $event)),
                    class: _normalizeClass(_ctx.v$.form.login.$error ? 'p-invalid' : ''),
                    disabled: _ctx.isEditable !== ''
                  }, null, 8, ["modelValue", "class", "disabled"]),
                  _createVNode(_component_Errors, {
                    errors: _ctx.v$.form.login.$errors
                  }, null, 8, ["errors"])
                ]),
                (!_ctx.isEditable && _ctx.userService.role !== 'APPLICATION_ADMIN')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createElementVNode("p", {
                        class: _normalizeClass(`mb-2 ${
              _ctx.service.role == 'ADMINISTRATOR' ? 'text-gray-500' : ''
            }`)
                      }, _toDisplayString(_ctx.$t("labels.generic", { pt: "Tipo de usuário", en: "User type" })), 3),
                      _createVNode(_component_Dropdown, {
                        id: "role-input",
                        modelValue: _ctx.form.role,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.role) = $event)),
                        options: _ctx.userRole(),
                        optionLabel: "name",
                        optionValue: "code",
                        placeholder: "Selecione o tipo",
                        class: _normalizeClass(_ctx.v$.form.role.$error ? 'p-invalid' : ''),
                        disabled: _ctx.service.role == 'ADMINISTRATOR'
                      }, null, 8, ["modelValue", "options", "class", "disabled"]),
                      _createVNode(_component_Errors, {
                        errors: _ctx.v$.form.role.$errors
                      }, null, 8, ["errors"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.form.status !== 'WAITING_ACTIVATION' && _ctx.isEditable)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _hoisted_12,
                      _createVNode(_component_Dropdown, {
                        modelValue: _ctx.form.status,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.status) = $event)),
                        options: _ctx.userStatus,
                        optionLabel: "name",
                        optionValue: "code",
                        placeholder: "Selecione o status",
                        class: _normalizeClass(_ctx.v$.form.status.$error ? 'p-invalid' : '')
                      }, null, 8, ["modelValue", "options", "class"]),
                      _createVNode(_component_Errors, {
                        errors: _ctx.v$.form.status.$errors
                      }, null, 8, ["errors"])
                    ]))
                  : _createCommentVNode("", true),
                (
            Boolean(_ctx.isEditable) ||
            _ctx.userService.role?.includes('APPLICATION_ADMIN')
          )
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("p", {
                        class: _normalizeClass(`mb-2 ${Boolean(_ctx.isEditable) ? 'text-gray-500' : ''}`)
                      }, _toDisplayString(_ctx.$t("labels.generic", { pt: "Organização", en: "Organization" })), 3),
                      _createVNode(_component_AutoComplete, {
                        id: "organization-input",
                        modelValue: _ctx.autocomplete.selected,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.autocomplete.selected) = $event)),
                        suggestions: _ctx.autocomplete.sugestions,
                        forceSelection: true,
                        onComplete: _cache[7] || (_cache[7] = ($event: any) => (_ctx.searchForOrgs($event))),
                        placeholder: "Selecione a organização",
                        optionLabel: "name",
                        class: _normalizeClass(_ctx.v$.autocomplete.selected.$error ? 'p-invalid' : ''),
                        disabled: 
              Boolean(_ctx.isEditable) || _ctx.userService.role?.includes('ADMINISTRATOR')
            
                      }, null, 8, ["modelValue", "suggestions", "class", "disabled"]),
                      _createVNode(_component_Errors, {
                        errors: _ctx.v$.autocomplete.selected.$errors
                      }, null, 8, ["errors"])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.form.role?.includes('STUDENT'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", { pt: "Curso(s)", en: "Course(s)" })), 1),
                        _createVNode(_component_Button, {
                          label: "Adicionar curso",
                          icon: "pi pi-plus",
                          class: "btn-simple",
                          onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.openModal()))
                        })
                      ]),
                      (_ctx.courses.length == 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("labels.generic", {
                  pt: "Este usuário ainda não está vinculado a nenhum curso.",
                  en: "This user is not yet linked to any course.",
                })), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.courses?.length !== 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course, i) => {
                                return (_openBlock(), _createBlock(_component_Card, {
                                  key: i,
                                  class: "col-span-12 md:col-span-3 motion-safe:animate-fadeIn border-b-2 border-b-h-primary-500 overflow-hidden"
                                }, {
                                  header: _withCtx(() => [
                                    _createElementVNode("img", {
                                      src: course?.file?.url || _ctx.emptyImg,
                                      class: "object-cover w-full",
                                      style: {"height":"13rem"}
                                    }, null, 8, _hoisted_20)
                                  ]),
                                  title: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_21, [
                                      _createElementVNode("p", _hoisted_22, _toDisplayString(course?.name), 1),
                                      _createVNode(_component_v_icon, {
                                        name: "hi-solid-minus-circle",
                                        class: "text-h-error-400 cursor-pointer",
                                        onClick: ($event: any) => (_ctx.removeCourse(_ctx.courses, i))
                                      }, null, 8, ["onClick"])
                                    ])
                                  ]),
                                  subtitle: _withCtx(() => [
                                    _createElementVNode("p", _hoisted_23, _toDisplayString(course?.description), 1)
                                  ]),
                                  _: 2
                                }, 1024))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_24, [
                  _createVNode(_component_Button, {
                    label: "Cancelar",
                    class: "btn-outline",
                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.confirmModal()))
                  }),
                  _createVNode(_component_Button, {
                    type: "submit",
                    label: "Salvar",
                    class: "btn-primary"
                  })
                ])
              ], 32))
            : _createCommentVNode("", true),
          _createVNode(_component_ConfirmDialog),
          _createVNode(_component_Dialog, {
            header: "Adicionar curso(s)",
            visible: _ctx.displayModal,
            "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.displayModal) = $event)),
            onHide: _cache[16] || (_cache[16] = ($event: any) => (_ctx.closeModal())),
            draggable: false,
            breakpoints: { '960px': '75vw', '640px': '90vw' },
            style: { width: '35vw' },
            class: "custom-modal",
            modal: true
          }, {
            footer: _withCtx(() => [
              _createVNode(_component_Button, {
                label: "Cancelar",
                onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.closeModal())),
                class: "btn-simple"
              }),
              _createVNode(_component_Button, {
                label: "Adicionar",
                onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.addCourse())),
                class: "btn-primary"
              })
            ]),
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_25, [
                _hoisted_26,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseField, (item, i) => {
                  return (_openBlock(), _createElementBlock("section", {
                    class: "flex items-center gap-3",
                    key: i
                  }, [
                    _createVNode(_component_AutoComplete, {
                      id: "course-input",
                      modelValue: _ctx.courseField[i],
                      "onUpdate:modelValue": ($event: any) => ((_ctx.courseField[i]) = $event),
                      suggestions: _ctx.autocomplete.sugestionsCourse,
                      forceSelection: true,
                      onComplete: _cache[11] || (_cache[11] = ($event: any) => (_ctx.searchForCourses($event))),
                      placeholder: "Selecione o curso",
                      optionLabel: "name",
                      class: _normalizeClass(`my-2 ${i > 0 ? 'w-11/12' : 'w-full'}`)
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "suggestions", "class"]),
                    (i > 0)
                      ? (_openBlock(), _createBlock(_component_v_icon, {
                          key: 0,
                          name: "hi-solid-minus-circle",
                          class: "text-h-error-400 cursor-pointer hover:scale-125",
                          onClick: ($event: any) => (_ctx.service.removeCourseField(_ctx.courseField, i))
                        }, null, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]),
              _createVNode(_component_Button, {
                label: "Adicionar curso",
                icon: "pi pi-plus",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.service.addCourseField(_ctx.courseField))),
                class: "btn-simple"
              })
            ]),
            _: 1
          }, 8, ["visible"])
        ]))
      : _createCommentVNode("", true)
  ]))
}